import { connect } from 'react-redux';
import {
  deleteSavedTouristAction,
  updateSavedTouristAction,
} from 'src/routes/Checkout/store/client/slice';
import MobileMenu from './MobileMenu';

const mapDispatchToProps = (dispatch) => ({
  deleteSavedTourist: (tourist) => {
    dispatch(updateSavedTouristAction({ ...tourist, state: 'deleting' }));
    dispatch(deleteSavedTouristAction(tourist));
  },
});

export default connect(null, mapDispatchToProps)(MobileMenu);
